import ButtonRefreshArrow from '@berlitz/streamline-icons/lib/bold/01-Interface-Essential/42-Multimedia-Controls/ButtonRefreshArrow'
import WithUserTime, { WithUserTimeProps } from '@hocs/WithUserTime'
import { REFRESH_INTERVAL, RELATIVE_TIME } from '@utils/constants/time'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { RefreshButton, RefreshTime, Wrapper } from './style'
import useTimeFormat from '@hooks/useTimeFormat'
import { DATE_FORMAT } from '@utils/constants'

interface LastRefreshProps extends WithUserTimeProps {
  loading: boolean
  handleRefresh: () => void
  alignRight?: boolean
}

const LastRefresh: React.FC<LastRefreshProps> = ({ loading, handleRefresh, alignRight, getUserDate }) => {
  const { convertToUserTimeFormats } = useTimeFormat()
  const [lastRefresh, setLastRefresh] = useState(getUserDate())
  const [time, setTime] = useState(moment())

  useEffect(() => {
    moment.locale('en', {
      relativeTime: RELATIVE_TIME,
    })
  }, [])

  setInterval(() => {
    setTime(moment())
  }, REFRESH_INTERVAL)

  const refresh = () => {
    setLastRefresh(moment())
    handleRefresh()
  }

  return (
    <Wrapper alignRight={alignRight}>
      <RefreshTime>
        <FormattedMessage id="Last refresh" />
        <div>
          {convertToUserTimeFormats(lastRefresh.format(DATE_FORMAT.HM), DATE_FORMAT.HM)} ({lastRefresh.from(time)})
        </div>
      </RefreshTime>
      <RefreshButton ghost className="btn-ghost" small disabled={loading} onClick={refresh}>
        <ButtonRefreshArrow />
      </RefreshButton>
    </Wrapper>
  )
}

export default WithUserTime(LastRefresh)
